{
  "about": {
    "paragraph": "نحن ملتزمون بمعالجة تحديات قانون AGEC وإعلام عملائنا حول أصل والخصائص البيئية لمنتجاتنا.",
    "title": "حول"
  },
  "lastUpdate": "تاريخ آخر تحديث: ",
  "loading": {
    "dataPending": "يجمع حالياً هذه المعلومات",
    "pendingLocation": "الموقع معلق"
  },
  "activities": {
    "APPAREL_MANUFACTURING": "تصنيع الملابس",
    "FOOTWEAR_FINISHING": "تشطيب الأحذية",
    "FOOTWEAR_STITCHING": "خياطة الأحذية",
    "FOOTWEAR_ASSEMBLING": "تجميع الأحذية",
    "FABRIC_WEAVING_OR_KNITTING": "نسج أو حياكة الأقمشة",
    "FABRIC_DYEING_PRINTING": "صباغة أو طباعة الأقمشة",
    "YARN_PROVIDER": "مورد الخيوط",
    "YARN_DYEING_PRINTING": "صباغة أو طباعة الخيوط",
    "LEATHER_TANNING": "دباغة الجلود",
    "LEATHER_DYEING_PRINTING": "صباغة أو طباعة الجلود",
    "ACCESSORY_PROVIDER": "مورد الإكسسوارات",
    "YARN_MATERIAL_PRODUCTION": "إنتاج مواد الخيوط",
    "FABRIC_SPINNING": "غزل الأقمشة",
    "FABRIC_MATERIAL_PRODUCTION": "إنتاج مواد الأقمشة",
    "LEATHER_MATERIAL_PRODUCTION": "إنتاج مواد الجلود",
    "LEATHER_FARM": "مزرعة تربية",
    "ACCESSORY_RAW_MATERIAL_PROVIDER": "مورد المواد الخام للإكسسوارات",
    "COATING": "طلاء"
  },
  "other": {
    "microplastics_bold": "يطلق جزيئات بلاستيكية دقيقة ",
    "paragraph1": "يحتوي هذا المنتج على ",
    "paragraph1_100": "يحتوي هذا المنتج على 100% مواد معاد تدويرها.",
    "paragraph2_1": "هذا المنتج ",
    "paragraph2_2": "  في البيئة أثناء الغسيل: ",
    "paragraph2_3": "بالكتلة من المنتج يتكون من ألياف اصطناعية.",
    "paragraph3": "معلومات حول وجود المواد الخطرة المحتملة في التطبيق: ",
    "recycled_matertials_bold": "على الأقل {{percent}}% مواد معاد تدويرها.",
    "recycled_matertials_bold_50": "أكثر من 50% ",
    "title": "الخصائص والميزات البيئية الأخرى"
  },
  "packaging": {
    "recyclable": "قابل لإعادة التدوير: العبوة قابلة لإعادة التدوير.",
    "recycled": "المواد المعاد تدويرها: تحتوي العبوة على {{percent}}% مواد معاد تدويرها على الأقل.",
    "recycled_100": "المواد المعاد تدويرها: تحتوي العبوة على 100% مواد معاد تدويرها.",
    "title": "الخصائص والميزات البيئية للعبوة"
  },
  "title": "ورقة المنتج حول الخصائص أو الصفات البيئية",
  "traceability": {
    "paragraph": "يشير هذا إلى أصل منتجك في مراحل الإنتاج الثلاث الأولى، من إنشائه إلى نسج وصباغة مادته الرئيسية.",
    "title": "تتبع المنتج"
  },
  "ecoScore": {
    "title": "النقاط البيئية"
  }
}
